import React from "react";
import TablaModeracion from "js/pages/Admin/Programa/ModeracionFacturaPorPuntos/Tabla";

function Moderacion(props) {
  return <TablaModeracion {...props} />;
}

export default Moderacion;
